import { render, staticRenderFns } from "./FlowStepRecord.vue?vue&type=template&id=6b754756&"
import script from "./FlowStepRecord.vue?vue&type=script&lang=ts&"
export * from "./FlowStepRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports